/*
 * Swap a video facade for the real YouTube embed, on click and not before.
 *
 * The whole point is what does NOT happen: until someone clicks, this page makes no request to
 * youtube.com at all. Live's equivalent page fires thirteen on load.
 *
 * DELEGATED FROM THE DOCUMENT, matching assets/auto-close-details.js and assets/contact-routes.js,
 * so it needs no per-block wiring and survives a section being re-rendered by the theme editor.
 *
 * `autoplay=1` IS CORRECT HERE and is not an autoplay dark pattern: the iframe is created by a
 * click, so the video starts because a person asked it to. Without it they would have to click a
 * second time, having already told us what they wanted.
 *
 * FOCUS MOVES TO THE IFRAME. The button that had focus is being removed from the document; leaving
 * focus to fall back to <body> loses a keyboard user's place entirely.
 */
(function videoFacades() {
  document.addEventListener('click', function (event) {
    const button = event.target instanceof Element ? event.target.closest('[data-video-facade]') : null;
    if (!button) return;

    const id = button.getAttribute('data-video-facade');
    const title = button.getAttribute('data-video-title') || 'Video';
    if (!id) return;

    const params = new URLSearchParams({
      autoplay: '1',
      rel: '0',
      playsinline: '1',
    });

    const frame = document.createElement('iframe');
    frame.className = 'video-facade__frame-embed';
    // youtube-nocookie serves the same player without setting tracking cookies until playback.
    frame.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?${params}`;
    frame.title = title;
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    frame.allowFullscreen = true;
    frame.setAttribute('tabindex', '0');

    const wrapper = document.createElement('div');
    wrapper.className = 'video-facade__frame';
    wrapper.appendChild(frame);

    button.replaceWith(wrapper);
    frame.focus({ preventScroll: true });
  });
})();
